// this file is automatically generated by git.version.ts script
export const versions = {commit: 'c29e990f', tag: '2025.12.001-RELEASE'};
